// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"236":"translation-en-error-json","535":"translation-en-login-json"}[chunkId] + "." + {"236":"1cbcb76bff0e36bbd2ec","535":"26e372949b0450361ad8"}[chunkId] + ".chunk.js";
};